<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="30%"
    title="报名登录提示"
    center>
    <p v-for="(item, index) in toastValue" :key="index">{{item}}</p>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="dialogVisible = false">确 认</el-button>
    </span>
  </el-dialog>
</template>
<script>
import {Dialog, Button } from 'element-ui'

export default {
  components: {
    ElButton: Button,
    ElDialog: Dialog,
  },
  data() {
    return {
      dialogVisible: true,
      hideTimer: null,
    };
  },
  props:{
    toastValue: {
      type: Array
    }
  },
  mounted() {},
  computed:{
  },
  methods: {
  },
  watch: {
    dialogVisible(){
      this.$emit('hideUnloginToast', false)
    }
  }
}

</script>

<style lang="less" scoped>
/deep/ .el-dialog__body {
  padding-top: 20px!important;
  padding-bottom: 20px!important;
}
</style>